//封装高阶组件
//有token，正常跳转；无token，返回登录

import { getToken,removeToken } from "@/utils";
import { Navigate } from "react-router-dom";

export function AuthRoute({ children }) {
  const token = getToken() ? JSON.parse(getToken()).token : ""
  const expireTime = getToken() ? JSON.parse(getToken()).time : ""
  const localTime = new Date().getTime();
  if (token) {
    if (localTime < expireTime) {
      return <>{children}</>
    } else {
      removeToken()
      window.alert("当前用户登录超时，请重新登录!/nThe current user login has timed out. Please log in again ")
      return (<Navigate to={'/login'} replace />)
    }
  } else {
    //window.alert("用户token丢失，请重新登录!")
    return <Navigate to={'/login'} replace />
  }
}